import { restore } from 'apis/Folder/Folder';
import { useAppStore } from 'hooks/useAppStore';
import { Document } from 'models/Content';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { ErrorResponse } from 'types';
import { fetchServerError } from 'utils';

export const useRestore = () => {
  const { queryKey } = useAppStore();
  const queryClient = useQueryClient();

  return useMutation(restore, {
    onSuccess: (_, contentId) => {
      queryClient.setQueryData<Document[]>(queryKey, (contents: Document[]) =>
        contents.filter(content => content.id != contentId),
      );
      toast.success('Item has been restored.');
    },
    onError: (error: ErrorResponse) => {
      toast.error(fetchServerError(error));
    },
  });
};
